import React, { useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import ActionSuccessSelected from "@/icons/Action/Success/Selected";

import { Icon } from "@/components/Icon";
import IndicatorContext from "./StepIndicatorContext";

import styles from "./StepIndicator.scss";

function Step({ stepOrder, content, children: labelContent, ...restProps }) {
  const {
    onStepChange,
    currentStep,
    isNarrow,
    allowUserClick,
    preventIncompleteStepClick,
    highestCompletedStep,
  } = useContext(IndicatorContext);

  const isCompleted = currentStep > stepOrder;
  const isCurrent = currentStep === stepOrder;
  const allowClick =
    allowUserClick &&
    (!preventIncompleteStepClick || stepOrder <= highestCompletedStep);

  const completedIcon = (
    <Icon
      icon={ActionSuccessSelected}
      size={Icon.Size.parent}
      customClass={styles.completedIcon}
    />
  );

  return (
    <div
      className={cx(styles.step, {
        [styles.stepCompleted]: isCompleted || isCurrent,
        [styles.stepWide]: !isNarrow,
      })}
    >
      <button
        className={styles.circle}
        onClick={() => onStepChange(stepOrder)}
        onKeyDown={() => onStepChange(stepOrder)}
        type="button"
        disabled={!allowClick}
        data-testid="stepBtn"
        {...restProps}
      >
        {isCompleted ? completedIcon : <span>{content || stepOrder}</span>}
      </button>

      <p className={styles.label}>{labelContent}</p>
    </div>
  );
}

Step.propTypes = {
  stepOrder: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  content: PropTypes.node,
};

Step.defaultProps = {
  children: "",
  stepOrder: 0,
  content: "",
};

Step.displayName = "StepIndicator.Step";

export default Step;
